(function($) {

    'use strict';

    var CONST = {
        businessDetailsUpdateForm:'data_update_business_details_form',
        businessDetailsUpdateBtn: 'data-update-business-details-btn',
        businessDetailsUpdateError: 'data-business-details-update-error',
        businessDetailsUpdateSuccess: 'data-business-details-update-success',
        businessDetailsUpdateVatSection: 'data-update-business-details-vat'
    };

    var REQUEST_URL = '/api/sitecore/BusinessDetailsUpdate/Update';
    var hiddenClass = 'hidden';
    var hasSuccessClass = 'has-success';
    var hasErrorClass = 'has-error';

    var Utility = {
        getDataElement: function(elName) {
            return $('[' + elName + ']');
        }
    };

    var $updateSuccessSection = Utility.getDataElement(CONST.businessDetailsUpdateSuccess).eq(0);
    var $updateErrorSection = Utility.getDataElement(CONST.businessDetailsUpdateError).eq(0);
    var $updateVatSection = Utility.getDataElement(CONST.businessDetailsUpdateVatSection).eq(0);

    function handleAjaxSuccess(response) {
        if (response.success) {
            $updateSuccessSection.removeClass(hiddenClass);
            if (!$updateErrorSection.hasClass(hiddenClass)) {
                $updateErrorSection.addClass(hiddenClass);
            }
        } else {
            displayAjaxError(response);
        }
    }

    function displayAjaxError(response) {
        if (response.vaterror) {
            if ($updateVatSection.hasClass(hasSuccessClass)) {
                $updateVatSection.removeClass(hasSuccessClass);
            }
            $updateVatSection.addClass(hasErrorClass);

            $updateErrorSection.removeClass(hiddenClass);
            if (!$updateSuccessSection.hasClass(hiddenClass)) {
                $updateSuccessSection.addClass(hiddenClass);
            }
        }
        else {
            $updateErrorSection.removeClass(hiddenClass);
            if (!$updateSuccessSection.hasClass(hiddenClass)) {
                $updateSuccessSection.addClass(hiddenClass);
            }
        }
    }

    function handleButtonClick(event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        var data = Utility.getDataElement(CONST.businessDetailsUpdateForm).eq(0).serialize();
        
        $.post(REQUEST_URL, data)
            .done(handleAjaxSuccess)
            .fail(displayAjaxError);
    }

    function init() {
        var $businessDetailsUpdateBtn = $('[' + CONST.businessDetailsUpdateBtn + ']');
        $businessDetailsUpdateBtn.on('click', handleButtonClick);
    }

    init();

})($jq);
